export const DEFAULT_MAX_FEE_PERCENT = 50
